import { jsx as e } from "react/jsx-runtime";

import { memo as r } from "react";

import o from "@ui-components-3/icons/lib/regular/Calendar";

import t from "../hooks/useGlobals.js";

const a = r((({disabled: r}) => {
    const {model: a} = t();
    return e("button", {
        className: "btn-neutral-borderless p-xs",
        type: "button",
        "aria-label": "open date picker",
        onClick: () => a.toggle(!0),
        disabled: r,
        children: e(o, {
            "aria-hidden": "true"
        })
    });
}));

export { a as default };
//# sourceMappingURL=CalendarButton.js.map
